export const SITE_URL = process.env.REACT_APP_SITE_URL || "https://najm-etar-tires.preview.emergentagent.com";

export const BUSINESS = {
  nameAr: "بنشر متنقل نجم الإطار",
  nameEn: "Najm Al Etar Mobile Tire Service",
  shortName: "نجم الإطار",
  slogan: "نصلك أينما كنت",
  tagline: "تعطلت؟ لا توقف رحلتك.\nنجم الإطار يصلك إلى موقعك.",
  city: "الرياض",
  phoneDisplay: "0538644740",
  phoneIntl: "+966538644740",
  telLink: "tel:+966538644740",
  whatsappNumber: "966538644740",
  whatsappLink: "https://wa.me/966538644740",
  hours: "24 ساعة — طوال أيام الأسبوع",
  siteUrl: SITE_URL,
};

export const waLink = (text) =>
  `${BUSINESS.whatsappLink}?text=${encodeURIComponent(text)}`;

export const WA_DEFAULT = waLink(
  "مرحباً، أحتاج خدمة بنشر متنقل في الرياض."
);

export const WA_ORDER = waLink(
  "مرحباً، أرغب في طلب بنشر متنقل في الرياض."
);

export const MAPS_LINK = (lat, lng) =>
  `https://www.google.com/maps?q=${lat},${lng}`;

export const SERVICES_LIST = [
  { icon: "wrench", label: "إصلاح البنشر" },
  { icon: "repeat", label: "تغيير وتركيب الكفرات" },
  { icon: "package", label: "بيع الإطارات" },
  { icon: "disc", label: "بيع وتركيب الجنوط" },
  { icon: "radar", label: "برمجة حساسات الكفرات TPMS" },
  { icon: "scale", label: "ترصيص الإطارات" },
  { icon: "wind", label: "فحص وتعبئة الهواء" },
  { icon: "truck", label: "خدمة بنشر متنقل على الطريق" },
];
